import React from 'react'
import Accordian from './Accordian'

export const faqs = [
    {
        id: 0,
        question: 'How is this course personalised for me?',
        answer: 'Our domain experts (with 30+ years of combined experience) along with our AI engine analyse your skills, goals & answers to identify what you need to learn. We then build a detailed syllabus accordingly for you. And the personalisation doesn’t end here. Once you start learning, your course will be further personalised to you as per your needs.'

    },
    {
        id: 1,
        question: 'What all courses do you offer?',
        answer: 'Our personalisation technology works across domains, from career skills like Java to even hobbies like baking. Most users use us to learn work related skills in the domain of Programming, Marketing, Data Science, Design, Business & lots of different tools.'

    },
    {
        id: 2,
        question: 'Does the course really help in jobs?',
        answer: 'Yess! If you learn properly, do your assessments & projects and then showcase your skills in your CV & portfolio to employers it will make a huge difference in your job applications & even your own confidence. Our learners work at top companies from Amazon to TCS and many have gone on to become freelancers & entrepreneurs.'

    },
    {
        id: 3,
        question: 'Does LearnTube make the content too?',
        answer: 'We make personalised, certified courses. We do not make the videos in the course. Those are sourced from across the internet to make sure we get the very best content for you. Most videos are from top YouTube creators. We do the hard work of figuring out what you need to learn, finding the very best videos for it, arranging it in the best order, assessing your skills, solving your doubts, giving you projects to do & then certifying you.'

    },
    {
        id: 4,
        question: 'How do I get certified?',
        answer: 'Once you complete the course & assessments you will get certified immediately. Our certificate is recognised by hundreds of companies.'

    },
    {
        id: 5,
        question: 'Is there any refund policy?',
        answer: 'There sure is. While completing your course, if you find a cheaper, more personalised course than ours you will get your money back! Just reach out to us within 7 days of purchase with the details on hello@careerninja.in'

    },
    {
        id: 6,
        question: 'What all will be unlimited?',
        answer: 'You will be able to create unlimited personalised courses on any topic, get certified upon completing each of them, get unlimited doubt solving support & feedback in multiple languages. Note: To prevent any abuse of the system, at a time you can learn from 3 courses & the moment you complete one of them you can start another one. There is no limit to how many courses you can complete every month.'
    },
    {
        id: 7,
        question: '',
        answer: ''
    }
]

const FAQSection = () => {
    return (
        <div className=''>
            <div className='bg-[#5D8AB7] rounded-xl'>
                <div className='grid md:grid-cols-2 rounded-xl gap-y-[1px] md:gap-x-[1px] bg-[#5D8AB7]'>
                    {faqs.map(({ question, answer }, index) => (
                        <Accordian title={question} key={index} index={index} length={faqs?.length} content={answer}/>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default FAQSection